import JSZip from 'jszip';

// utilities
import { getCanvasBlob, dataURItoBlob } from '@fluke/irviewer/utilities';

const downloadFile = (file) => {
  const url = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = url;
  link.download = file.name || `export_${Date.now()}.zip`;
  link.click();
  URL.revokeObjectURL(url);
};

export default async function handleImageExport(groupImageData = {}) {
  const zip = new JSZip();

  const getObjectAsJSONFile = (jsonObject) => {
    const jsonString = JSON.stringify(jsonObject);
    return new File([jsonString], 'newTxtAreaFile.json', {
      type: 'application/json',
    });
  };

  for (const [imageId, imageData] of Object.entries(groupImageData)) {
    const { DATA = {} } = imageData || {};
    const { img = {}, json = {} } = DATA;

    const jsonFile = getObjectAsJSONFile(json);
    zip.file(`preview_${imageId}.json`, jsonFile);

    // Assuming you have a function to get the canvas blob from the image
    const imageBlob = getCanvasBlob(dataURItoBlob(img.src));
    zip.file(`preview_${imageId}.jpeg`, imageBlob);
  }

  const zipBlob = await zip.generateAsync({ type: 'blob' });
  downloadFile(zipBlob);
}
